import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var FolderLockSvg = function FolderLockSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2 2.749h6.568l3.721 3.682H22v4.372h-1.395V7.81H11.71L7.991 4.13H3.394v16.238h7.675v1.381H2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20.405 16.16H22v5.589h-8.837V16.16h1.594v-1.427a2.78 2.78 0 0 1 .848-1.938 2.84 2.84 0 0 1 1.976-.798 2.84 2.84 0 0 1 1.976.798 2.78 2.78 0 0 1 .848 1.938v1.427m-1.396 0v-1.405a1.4 1.4 0 0 0-.428-.974 1.437 1.437 0 0 0-2 0c-.265.258-.419.607-.428.974v1.405zm-4.45 1.38v2.828h6.046v-2.827z",
    clipRule: "evenodd"
  }));
};
export var FolderLock = function FolderLock(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: FolderLockSvg
  }));
};